import type React from 'react';

import { HowChangeWorks } from './components/HowChangeWorks';
import { InfoCards } from './components/InfoCards';
import { WhoUses } from './components/WhoUses';

export const PageBody: React.FC<EmptyProps> = () => {
	return (
		<>
			<WhoUses />
			<HowChangeWorks />
			<InfoCards />
		</>
	);
};
